export default "__VITE_ASSET__DRP0J3bX__"